var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClutterBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.7,236.05a16.1,16.1,0,0,0,0,8.37h17.22s-1.84-5.31,0-8.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462,305.85c27.74-48.45,29.61-113,10.46-164.76C456,96.54,419.28,62.55,376.9,42.31,327.73,18.83,269.12,11.85,216.35,26.66c-13.88,3.9-27.39,7.47-40.48,13.88-53.65,26.25-43.3,90.93-62.12,113.43-15.83,18.93-46.12,13.35-65.21,27.86C-3,221-3.11,319.92,56.34,350.85,119.4,383.66,393.29,425.85,462,305.85Z",
    style: {
      fill: "#F92323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,305.85c27.74-48.45,29.61-113,10.46-164.76C456,96.54,419.28,62.55,376.9,42.31,327.73,18.83,269.12,11.85,216.35,26.66c-13.88,3.9-27.39,7.47-40.48,13.88-53.65,26.25-43.3,90.93-62.12,113.43-15.83,18.93-46.12,13.35-65.21,27.86C-3,221-3.11,319.92,56.34,350.85,119.4,383.66,393.29,425.85,462,305.85Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-61"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.82,
    cy: 428.35,
    rx: 223.11,
    ry: 51.97,
    style: {
      fill: "#F92323"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.82,
    cy: 428.35,
    rx: 223.11,
    ry: 51.97,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.6,
    y: 51.03,
    width: 135.28,
    height: 170.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.2,
    y: 61.89,
    width: 118.08,
    height: 149.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.2,
    y: 132,
    width: 118.08,
    height: 13.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 151.8,
    x2: 242.22,
    y2: 151.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 157.68,
    x2: 242.22,
    y2: 157.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 163.56,
    x2: 242.22,
    y2: 163.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 169.44,
    x2: 242.22,
    y2: 169.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 175.32,
    x2: 242.22,
    y2: 175.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 181.19,
    x2: 242.22,
    y2: 181.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 187.07,
    x2: 242.22,
    y2: 187.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 192.95,
    x2: 242.22,
    y2: 192.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 198.83,
    x2: 242.22,
    y2: 198.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6,
    y1: 204.7,
    x2: 242.22,
    y2: 204.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.41,
    y: 91.57,
    width: 59.25,
    height: 82.29,
    transform: "translate(11.19 -28.3) rotate(4.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 99.47,
    width: 47.87,
    height: 66.49,
    transform: "translate(11.19 -28.3) rotate(4.36)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.58,
    y: 136.33,
    width: 45.42,
    height: 59.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.13,
    y: 143.58,
    width: 34.32,
    height: 44.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--furniture-2--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.53,
    y: 224.37,
    width: 11.8,
    height: 19.45,
    rx: 2.51,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.38,234.73a3.95,3.95,0,1,1-3.95-3.94A4,4,0,0,1,162.38,234.73Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.63,
    y: 223.27,
    width: 9.61,
    height: 1.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.63,
    y: 243.73,
    width: 9.61,
    height: 1.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.79,
    y: 228.89,
    width: 11.8,
    height: 19.45,
    rx: 2.51,
    transform: "translate(420.3 56.93) rotate(90)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.05,242.56a3.95,3.95,0,1,1,3.94-3.95A4,4,0,0,1,181.05,242.56Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.02,
    y: 237.94,
    width: 9.61,
    height: 1.36,
    transform: "translate(430.44 46.79) rotate(90)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.57,
    y: 237.94,
    width: 9.61,
    height: 1.36,
    transform: "translate(409.99 67.24) rotate(90)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.61 225.37 200.3 225.37 202.3 244.84 211.62 244.84 213.61 225.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.53 234.49 203.36 242.62 210.56 242.62 211.39 234.49 202.53 234.49",
    style: {
      fill: "#F92323"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.51,
    y: 233.32,
    width: 12.99,
    height: 11.14,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.19,
    y: 182.28,
    width: 75.64,
    height: 53.37,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.43,
    y: 186.45,
    width: 69.14,
    height: 45.01,
    style: {
      fill: "#4a4a4a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.49,
    y: 243.07,
    width: 57.14,
    height: 1.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85,234.45s-15.35-23.41-13-28.78,10.36,3.83,10.36,3.83-11.89-31.47-3.83-38.37,10.74,28.4,10.74,28.4,7.29-20.34,13.05-12.67-8.83,23.79-8.83,23.79,10,.39,7.3,6.91-10,13.43-10,13.43Z",
    style: {
      fill: "#F92323"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.63,229.08S228.42,216,233,213.34s6.91,5.37,6.91,5.37.39-35.3,7.68-32.62,4.6,24.18,4.6,24.18,9.21-6.14,8.83,2.69-12.66,16.5-12.66,16.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.07,
    y1: 229.84,
    x2: 238.01,
    y2: 221.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.46,
    y1: 234.06,
    x2: 246.07,
    y2: 212.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.84,
    y1: 226.77,
    x2: 254.13,
    y2: 217.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.36 227.54 233.03 227.54 235.06 245.58 251.33 245.58 253.36 227.54",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.29,
    y: 245.28,
    width: 193.14,
    height: 105.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.59,
    y: 245.28,
    width: 114.14,
    height: 105.27,
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.53,
    y: 245.28,
    width: 198.67,
    height: 7.12,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.72,
    y: 299.69,
    width: 60.73,
    height: 29.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.72,
    y: 259.75,
    width: 60.73,
    height: 29.75,
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.88,
    y: 311.1,
    width: 22.42,
    height: 6.93,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.4,
    y: 328.22,
    width: 60.73,
    height: 22.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.12,
    y: 320.48,
    width: 60.73,
    height: 29.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.45,
    y: 320.48,
    width: 60.73,
    height: 29.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.61,
    y: 331.89,
    width: 22.42,
    height: 6.93,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.18,
    y: 268.93,
    width: 11.8,
    height: 19.45,
    rx: 2.51,
    transform: "translate(375.74 181.57) rotate(90)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.44,282.6a3.95,3.95,0,1,1,3.94-3.94A3.94,3.94,0,0,1,96.44,282.6Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.42,
    y: 277.98,
    width: 9.61,
    height: 1.36,
    transform: "translate(385.88 171.43) rotate(90)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.96,
    y: 277.98,
    width: 9.61,
    height: 1.36,
    transform: "translate(365.42 191.89) rotate(90)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.85,215.85H70.23A11.28,11.28,0,0,1,81.5,227.13v45.45a9.63,9.63,0,0,1-9.63,9.63H32.2a9.63,9.63,0,0,1-9.63-9.63V227.13A11.28,11.28,0,0,1,33.85,215.85Z",
    style: {
      fill: "#4a4a4a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.28,215.85H64.66a11.28,11.28,0,0,1,11.28,11.28v45.45a9.63,9.63,0,0,1-9.63,9.63H26.63A9.63,9.63,0,0,1,17,272.58V227.13A11.28,11.28,0,0,1,28.28,215.85Z",
    style: {
      fill: "#4a4a4a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.56,284.53H81.5a0,0,0,0,1,0,0v16.24a0,0,0,0,1,0,0H26.56a4,4,0,0,1-4-4v-8.25A4,4,0,0,1,26.56,284.53Z",
    style: {
      fill: "#4a4a4a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.33,284.53h55.88a3.05,3.05,0,0,1,3.05,3.05v10.13a3.05,3.05,0,0,1-3.05,3.05H64.33a0,0,0,0,1,0,0V284.53A0,0,0,0,1,64.33,284.53Z",
    style: {
      fill: "#4a4a4a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.43,355.79V314.23H85.8v-4.64H95.89v-8.35H45.31V247H36.49v53.83a8.8,8.8,0,0,0,6.5,8.49v.32H58v4.64H68.39V356l-29.23,7.2v3.25h5.1l.93-1.86h24.6v1.86H73.5v-1.86H74v-2.78h.15L74,364.61h24.6l.93,1.86h5.1v-3.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--furniture-1--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.71,
    y: 208.1,
    width: 5.53,
    height: 34.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.6,
    y: 161.3,
    width: 35.75,
    height: 51.22,
    transform: "translate(-17.02 45.64) rotate(-5.94)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.32,245.69h-31.7a5.9,5.9,0,0,1,5.9-5.9h19.9a5.9,5.9,0,0,1,5.9,5.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.25,
    y: 225.9,
    width: 53.41,
    height: 18.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.95,
    y: 220.85,
    width: 53.41,
    height: 6.63,
    transform: "translate(-9.35 16.56) rotate(-2.48)",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.92,
    y: 235.74,
    width: 43.42,
    height: 8.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.65,
    y1: 237.45,
    x2: 287.27,
    y2: 237.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.81,
    y1: 239.88,
    x2: 290.85,
    y2: 239.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.53,
    y1: 239.88,
    x2: 288.08,
    y2: 239.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.71,
    y1: 242.39,
    x2: 283.23,
    y2: 242.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7,236.05a16.1,16.1,0,0,0,0,8.37h17.22s-1.84-5.31,0-8.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.7,236.05a16.1,16.1,0,0,0,0,8.37h17.22s-1.84-5.31,0-8.37Z",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.24
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.7,236.05a16.1,16.1,0,0,0,0,8.37h17.22s-1.84-5.31,0-8.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.43,243v-6.07a.56.56,0,0,1,.56-.56h51.62a.42.42,0,0,0,.43-.42h0a.43.43,0,0,0-.43-.43h-53a.56.56,0,0,0-.56.56v7.77a.9.9,0,0,0,.91.91h52.66a.42.42,0,0,0,.43-.42h0a.43.43,0,0,0-.43-.43H280.34A.91.91,0,0,1,279.43,243Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,234.48c.31-1,1.43-5.24,0-7.94h50v7.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.41,
    y1: 228.31,
    x2: 301.79,
    y2: 228.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.25,
    y1: 230.74,
    x2: 298.21,
    y2: 230.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.53,
    y1: 230.74,
    x2: 300.98,
    y2: 230.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.35,
    y1: 233.25,
    x2: 305.83,
    y2: 233.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.59,233.67v-6.06A.58.58,0,0,0,309,227H278.46a.42.42,0,0,1-.42-.42h0a.42.42,0,0,1,.42-.43h53a.57.57,0,0,1,.56.57v7.76a.91.91,0,0,1-.91.91H278.46A.42.42,0,0,1,278,235h0a.42.42,0,0,1,.42-.43h30.22A.91.91,0,0,0,309.59,233.67Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.12,
    y: 245.28,
    width: 193.14,
    height: 105.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.5,
    y: 257.95,
    width: 86.8,
    height: 34.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.19,
    y: 273.88,
    width: 15.41,
    height: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.65,
    y: 257.95,
    width: 86.8,
    height: 34.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.34,
    y: 273.88,
    width: 15.41,
    height: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.65,
    y: 302.47,
    width: 86.8,
    height: 34.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.34,
    y: 318.4,
    width: 15.41,
    height: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.5,
    y: 302.48,
    width: 86.8,
    height: 34.78,
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.59,
    y: 302.48,
    width: 78.6,
    height: 34.78,
    style: {
      fill: "#737373",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.5,
    y: 316.46,
    width: 86.8,
    height: 34.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.5,
    y: 320.03,
    width: 86.8,
    height: 34.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.19,
    y: 336.28,
    width: 15.41,
    height: 2.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.74,302.48a11.65,11.65,0,0,0-5.89,3.47c-2.56,2.85-.57,11.4-.57,17.67s-3.42,19.66-3.42,19.66,7.13,3.7,8.27,3.7h1.14l.47-30.52a20.72,20.72,0,0,1,2.62-.17c1.42,0,6.31-.08,6.31-.08s-.85-5.7-4-9.41S391.74,302.48,391.74,302.48Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.67,316.21s-5.7-8.84-8.83-9.69-4,5.13-4,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.56,322.19s.29-10,4-10.54a10.21,10.21,0,0,1,6.84,1.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.35,
    y: 245.28,
    width: 198.67,
    height: 7.12,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.91,315.34s-2.53,18,.32,21.81,14.53,13.9,19.27,11.37,3.16-6.63-.63-10.74-7.9-8.22-8.21-11.06-1-11.06-1-11.06S456.07,315.34,452.91,315.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.23,337.15a37.13,37.13,0,0,0,5.15,5.15,38,38,0,0,0-1.68-7.05,8.52,8.52,0,0,0-4.82-5.35C451.94,333.09,452.29,335.9,453.23,337.15Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.5,348.52c3.42-1.82,3.54-4.47,1.93-7.34a25.92,25.92,0,0,0-6.42,7.21C469.77,349,471.34,349.14,472.5,348.52Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.47,315.34a44.93,44.93,0,0,1-1.58,5.69c-.95,2.53-1.58,7.9,0,10.43s8.21,3.79,9.79-1.27,3.16-13.59,3.16-13.59S430.47,313.13,424.47,315.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.68,330.19q.18-.57.36-1.2c-3.27-1.69-8.26-1.84-11.11-1.76a8.54,8.54,0,0,0,1,4.23C424.47,334,431.1,335.25,432.68,330.19Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.51 367.22 134.87 379.78 129.34 379.78 131.51 367.22",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.35,
    y: 376.06,
    width: 72.08,
    height: 58.26,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.51 367.22 125.44 376.06 125.44 434.32 131.51 425.48 131.51 367.22",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.43 367.22 53.35 376.06 125.44 376.06 131.51 367.22 59.43 367.22",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.43 375.91 59.43 367.22 53.45 375.91 59.43 375.91",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.35 376.06 50.29 391.39 123.26 391.39 125.44 376.06 53.35 376.06",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.2 433.74 34.98 439.94 57.11 451.89 87.22 445.25 64.2 433.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.51 433.08 63.28 439.28 85.42 451.24 115.53 444.59 92.51 433.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.15 446.25 38.93 452.45 61.06 464.4 91.17 457.76 68.15 446.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Couch--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.67,341.33s-1.74-67.41-25.57-75c-24.31-7.71-50.28-7.06-75.45-5.92-23.74,1.08-47.67.43-71.35,2-26.07,1.73-35.73,13.7-41.48,37.8a201.61,201.61,0,0,0-5.22,41.09l-5.81,17.43H374.48Z",
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.36,349.46v-15.1s-.58-11-13.36-12.21-47.65,26.15-47.07,32,7,47.07,11,48.81,14.53,9.88,23.82,5.23S169.36,349.46,169.36,349.46Z",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,349.46v-15.1s.58-11,13.37-12.21,47.65,26.15,47.07,32-7,47.07-11.05,48.81-14.52,9.88-23.82,5.23S344.26,349.46,344.26,349.46Z",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.36,349.46a26.92,26.92,0,0,1-3.06,2.73c-7.81,6.44-27.74,21.68-27.74,21.68H376.22l-32-26.15Z",
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.56 373.87 138.56 397.89 376.06 397.89 376.22 373.87 138.56 373.87",
    style: {
      fill: "#4a4a4a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,421.52l-7.44,23.3a3.08,3.08,0,0,0,2.93,4h0a3.06,3.06,0,0,0,2.52-1.32L146.7,422.1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.75,421.52l7.43,23.3a3.07,3.07,0,0,1-2.92,4h0a3.08,3.08,0,0,1-2.53-1.32L368.06,422.1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.79,347.29c-3.85-1.89-8.2-2.18-13.43.43-10.46,5.23-9.3,26.15-9.3,26.15v14.74a8.51,8.51,0,0,1-8.5,8.5H147.07a8.51,8.51,0,0,1-8.51-8.5V373.87s1.17-20.92-9.29-26.15c-5.23-2.61-9.59-2.32-13.44-.43a17.37,17.37,0,0,0-9.24,18c1.63,12.09,4.74,33.22,7.57,41.71,4.07,12.2,4.07,14.53,12.78,17.43,7.56,2.52,104.73.67,130.37.14,25.64.53,122.81,2.38,130.37-.14,8.72-2.9,8.72-5.23,12.78-17.43,2.83-8.49,5.94-29.63,7.58-41.71A17.36,17.36,0,0,0,398.79,347.29Z",
    style: {
      fill: "#4a4a4a",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15,357.51s7.32-1.55,10.08-1.24a10.84,10.84,0,0,1,5.76,2.24c1.84,1.22,19.48,0,21.32,2.74S203.6,364,198.69,364s0,.92,4.6,1.23,5.83,2.45,5.83,4.6S192,372.84,184,370.7s.3-4.91,2.45-5.83-3.37-2.76-8.89-2.76-4.29-2.14,3.07-3.68",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.92,354.44c1.16,5.33-.57,10.24-3.87,11s-6.92-3-8.09-8.35.57-10.24,3.87-11S181.75,349.1,182.92,354.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.12,
    cy: 356.36,
    rx: 6.12,
    ry: 9.88,
    transform: "translate(-72.02 45.35) rotate(-12.32)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,347.61l-17.8,4.77,3.46,15.86,18.17-3.09c3-.66,4.57-5.11,3.52-9.95S175.1,347,172.1,347.61Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.94,359.24c1,4.38-.46,8.41-3.18,9s-5.68-2.48-6.64-6.86.47-8.41,3.18-9S160,354.86,160.94,359.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.65,360.48l-3.21,1.24,21.94,10.1a49.7,49.7,0,0,0,11.09-3.2C243.37,365.91,252,362,252,362s8.38,4.69,12.32,4.69,10.6-.25,10.6-.25S267,362.46,264.81,361s-6.9-5.43-15.52-5.18-8.38-.74-15.29.74S206.65,360.48,206.65,360.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.49,351.07s-2,1.52-9.08,4-23.19,4-23.19,4l20.17,10.09s3.53,3,13.61-3,13.62-7.56,13.62-7.56a51.87,51.87,0,0,0,10.08,4.53c5.05,1.52,13.62,1.52,13.62,1.52s-9.58-4-14.12-7.57-6-4.53-6-4.53S243.05,357.12,235.49,351.07Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.49,351.07a25.81,25.81,0,0,0,15.13,7.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,420.19s7.32-1.55,10.08-1.24a10.91,10.91,0,0,1,5.76,2.24c1.84,1.22,19.48,0,21.32,2.74s-11.71,2.7-16.62,2.7,0,.92,4.6,1.23,5.82,2.45,5.82,4.6-17.16,3.06-25.13.92.3-4.91,2.45-5.83-3.37-2.76-8.89-2.76-4.29-2.14,3.06-3.68",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.63,
    cy: 415.82,
    rx: 9.88,
    ry: 6.12,
    transform: "translate(-115.77 667.79) rotate(-70.49)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 417.35,
    cy: 416.78,
    rx: 9.88,
    ry: 6.12,
    transform: "translate(-114.87 671) rotate(-70.49)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.45,425.27l17.64,5.35,5.42-15.31-17.06-6.95c-2.9-1-6.58,1.93-8.24,6.6S411.56,424.25,414.45,425.27Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.06,421.28c1.5-4.22,4.84-6.9,7.45-6s3.53,5.1,2,9.33-4.83,6.9-7.45,6S428.57,425.51,430.06,421.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.43,264.11s-.32,17.39-1,21.25-1,10-1,10,10.62,2.25,13.84,2.25,6.44-.32,6.44-.32V274.74a75.48,75.48,0,0,1,1-10l1-3.54s-8.05-1.61-14.17-1S187.43,264.11,187.43,264.11Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.57,261.86s.32,11.91.32,22.85-.64,23.18-.64,24.79,2.57,2.58,10.94,2.58,9-2.26,9-2.26v-48.6s-12.23-3.22-20.93,1",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.25,304.67s12.23,3.54,20.28-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.82,290.51s7.4,1.29,12.23,1.61a33.94,33.94,0,0,0,8-.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.35,456.91c0,8-16.54,14.55-36.94,14.55s-36.93-6.52-36.93-14.55,16.53-24.32,36.93-24.32S445.35,448.87,445.35,456.91Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 408.41,
    cy: 442.58,
    rx: 20.56,
    ry: 8.1,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 408.41,
    cy: 440.98,
    rx: 20.56,
    ry: 8.1,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.21,464.65a1.36,1.36,0,1,1-2.71,0,1.36,1.36,0,0,1,2.71,0Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.52,462.25a2.26,2.26,0,0,0-2.26,2.26,2.29,2.29,0,0,0,.35,1.22,1.48,1.48,0,0,0-1.14,1.43,1.51,1.51,0,1,0,3,0,1.77,1.77,0,0,0-.08-.4h.11a2.26,2.26,0,0,0,0-4.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.57,
    cy: 467.89,
    r: 1.43,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.62,473.11a1.36,1.36,0,1,1-1.35-1.36A1.35,1.35,0,0,1,310.62,473.11Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.93,470.71a2.26,2.26,0,0,0-2.26,2.26,2.18,2.18,0,0,0,.36,1.21,1.49,1.49,0,1,0,1.87,1.44,1.29,1.29,0,0,0-.08-.4h.11a2.26,2.26,0,0,0,0-4.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.42,476.35a1.44,1.44,0,1,1-1.43-1.43A1.43,1.43,0,0,1,309.42,476.35Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.89,472.42A.85.85,0,0,1,335,471a.86.86,0,0,1,1.16.31A.84.84,0,0,1,335.89,472.42Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,469.12a1.41,1.41,0,0,0-2.48.06.94.94,0,0,0-1.49,1.12,1,1,0,0,0,1.3.35,1.54,1.54,0,0,0,.19-.17l0,.06a1.42,1.42,0,1,0,2.46-1.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.75,472.79a.89.89,0,0,1-1.22-.33.9.9,0,1,1,1.22.33Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.47,476.63a.85.85,0,1,1,.31-1.16A.84.84,0,0,1,368.47,476.63Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3,473.33a1.4,1.4,0,0,0-2.48.06.94.94,0,1,0-.19,1.47,1.54,1.54,0,0,0,.19-.17l0,.06a1.42,1.42,0,1,0,2.45-1.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.33,477a.89.89,0,0,1-1.22-.32.9.9,0,0,1,.33-1.23.89.89,0,0,1,.89,1.55Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.18,441a1.36,1.36,0,1,1-1.36-1.35A1.36,1.36,0,0,1,407.18,441Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.49,438.56a2.26,2.26,0,0,0-2.26,2.26,2.21,2.21,0,0,0,.36,1.22,1.48,1.48,0,0,0-1.14,1.43,1.51,1.51,0,1,0,3,0,1.35,1.35,0,0,0-.08-.4h.11a2.26,2.26,0,0,0,0-4.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.54,
    cy: 444.2,
    r: 1.43,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.77,470.68a1.36,1.36,0,1,1-1.35-1.35A1.35,1.35,0,0,1,391.77,470.68Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.08,468.28a2.26,2.26,0,0,0-2.26,2.26,2.21,2.21,0,0,0,.36,1.22,1.48,1.48,0,0,0-1.14,1.43,1.51,1.51,0,1,0,3,0,1.35,1.35,0,0,0-.08-.4h.11a2.26,2.26,0,0,0,0-4.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.14,
    cy: 473.92,
    r: 1.43,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.11,471.43a1.36,1.36,0,1,1-1.36-1.36A1.35,1.35,0,0,1,351.11,471.43Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.41,469a2.25,2.25,0,0,0-1.9,3.47,1.49,1.49,0,0,0-1.14,1.44,1.51,1.51,0,0,0,3,0,1.35,1.35,0,0,0-.08-.4h.11a2.26,2.26,0,0,0,0-4.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.47,
    cy: 474.67,
    r: 1.43,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,467.09a1.36,1.36,0,1,1,.06-1.92A1.36,1.36,0,0,1,348.1,467.09Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.64,462a2.26,2.26,0,0,0-3.2-.1,2.39,2.39,0,0,0-.64,1.09,1.48,1.48,0,0,0-1.82.15,1.51,1.51,0,0,0,2.06,2.2,1.78,1.78,0,0,0,.23-.33s0,.06.07.08a2.26,2.26,0,1,0,3.3-3.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.91,468.42a1.43,1.43,0,1,1,.06-2A1.42,1.42,0,0,1,344.91,468.42Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.28,472.92a1,1,0,0,1-1.34,0,1,1,0,1,1,1.39-1.3A.94.94,0,0,1,379.28,472.92Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,469.36a1.59,1.59,0,0,0-2.25-.07,1.69,1.69,0,0,0-.45.77,1,1,0,1,0,.17,1.65,1,1,0,0,0,.17-.24.25.25,0,0,0,0,.07,1.59,1.59,0,0,0,2.32-2.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,473.86a1,1,0,1,1,0-1.42A1,1,0,0,1,377,473.86Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.82,467.27a1,1,0,0,1-1.34,0,1,1,0,1,1,1.34,0Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,463.71a1.59,1.59,0,0,0-2.25-.07,1.64,1.64,0,0,0-.45.77,1,1,0,0,0-1.28.1,1.06,1.06,0,1,0,1.45,1.55,1,1,0,0,0,.17-.24.25.25,0,0,0,0,.07,1.59,1.59,0,0,0,2.32-2.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,468.21a1,1,0,1,1,.05-1.42A1,1,0,0,1,371.58,468.21Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.87,451.21a1.36,1.36,0,1,1-1.36-1.35A1.36,1.36,0,0,1,304.87,451.21Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.18,448.81a2.26,2.26,0,0,0-2.26,2.26,2.21,2.21,0,0,0,.36,1.22,1.48,1.48,0,0,0-1.14,1.43,1.51,1.51,0,1,0,3,0,1.35,1.35,0,0,0-.08-.4h.11a2.26,2.26,0,0,0,0-4.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.23,
    cy: 454.45,
    r: 1.43,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.14,463.19a.85.85,0,1,1,.31-1.16A.85.85,0,0,1,308.14,463.19Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,459.89a1.41,1.41,0,0,0-1.93-.52,1.39,1.39,0,0,0-.55.58.94.94,0,1,0-.19,1.46.74.74,0,0,0,.19-.16l0,.06a1.42,1.42,0,1,0,2.45-1.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,463.55a.9.9,0,1,1-.9-1.55.9.9,0,0,1,.9,1.55Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.44,457.24a1.36,1.36,0,1,1-1.36-1.35A1.36,1.36,0,0,1,331.44,457.24Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.74,454.84a2.26,2.26,0,0,0-2.26,2.26,2.3,2.3,0,0,0,.36,1.22,1.48,1.48,0,0,0-1.14,1.43,1.51,1.51,0,1,0,3,0,1.35,1.35,0,0,0-.08-.4h.11a2.26,2.26,0,0,0,0-4.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.23,460.48a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,330.23,460.48Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.77,458a1.36,1.36,0,1,1-1.36-1.36A1.35,1.35,0,0,1,290.77,458Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,455.59a2.26,2.26,0,0,0-2.26,2.26,2.18,2.18,0,0,0,.36,1.21A1.49,1.49,0,0,0,283,460.5a1.51,1.51,0,0,0,3,0,1.67,1.67,0,0,0-.08-.4h.11a2.26,2.26,0,0,0,0-4.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.13,
    cy: 461.23,
    r: 1.43,
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.54,460.8a1.36,1.36,0,1,1,.06-1.92A1.36,1.36,0,0,1,268.54,460.8Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.08,455.73a2.26,2.26,0,0,0-3.2-.1,2.34,2.34,0,0,0-.64,1.09,1.48,1.48,0,0,0-1.82.15,1.51,1.51,0,0,0,2.06,2.2,1.78,1.78,0,0,0,.23-.33.5.5,0,0,1,.07.08,2.26,2.26,0,1,0,3.3-3.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.35,462.13a1.43,1.43,0,1,1,.06-2A1.42,1.42,0,0,1,265.35,462.13Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,459.48a1,1,0,1,1,0-1.35A1,1,0,0,1,319,459.48Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,455.92a1.58,1.58,0,0,0-2.24-.07,1.56,1.56,0,0,0-.45.77,1,1,0,0,0-1.29.1,1.07,1.07,0,0,0,0,1.5,1,1,0,0,0,1.49,0,1.31,1.31,0,0,0,.17-.24l0,.07a1.59,1.59,0,0,0,2.32-2.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.71,460.42a1,1,0,1,1,0-1.42A1,1,0,0,1,316.71,460.42Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.49,453.83a1,1,0,1,1,0-1.35A1,1,0,0,1,313.49,453.83Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46,450.27a1.58,1.58,0,0,0-2.24-.07,1.52,1.52,0,0,0-.45.77,1,1,0,0,0-1.29.1,1.07,1.07,0,0,0,0,1.5,1.06,1.06,0,0,0,1.49.05,1.31,1.31,0,0,0,.17-.24s0,.05,0,.06a1.58,1.58,0,1,0,2.31-2.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,454.77a1,1,0,1,1,0-1.42A1,1,0,0,1,311.25,454.77Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.33,348.61a1.17,1.17,0,1,1-1.17-1.17A1.17,1.17,0,0,1,212.33,348.61Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.28,346.54a1.95,1.95,0,0,0-1.64,3,1.28,1.28,0,0,0-1,1.24,1.3,1.3,0,0,0,2.6,0,1.28,1.28,0,0,0-.07-.35h.09a1.95,1.95,0,0,0,0-3.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.29,351.41a1.24,1.24,0,1,1-1.23-1.24A1.23,1.23,0,0,1,211.29,351.41Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,355.32a.73.73,0,1,1-.73-1.27.73.73,0,0,1,.73,1.27Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,352.47a1.22,1.22,0,0,0-1.67-.45,1.28,1.28,0,0,0-.48.5.8.8,0,0,0-1-.15.82.82,0,0,0,.82,1.42.77.77,0,0,0,.16-.15l0,.05a1.22,1.22,0,0,0,2.12-1.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.19,355.63a.78.78,0,1,1,.28-1.06A.77.77,0,0,1,185.19,355.63Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,359a.75.75,0,0,1-1-.27.74.74,0,1,1,1,.27Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,356.1a1.22,1.22,0,0,0-1.67-.45,1.19,1.19,0,0,0-.47.5.8.8,0,0,0-1-.15.82.82,0,0,0,.81,1.42.83.83,0,0,0,.17-.15s0,0,0,.05A1.22,1.22,0,1,0,215,356.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.3,359.26a.77.77,0,0,1-1.06-.28.78.78,0,1,1,1.06.28Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.16,354.46a1.17,1.17,0,1,1-1.17-1.17A1.17,1.17,0,0,1,200.16,354.46Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.11,352.39a2,2,0,0,0-2,1.95,2,2,0,0,0,.31,1.05,1.27,1.27,0,0,0-1,1.23,1.3,1.3,0,1,0,2.53-.34h.09a1.95,1.95,0,0,0,0-3.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.12,357.25a1.24,1.24,0,1,1-1.23-1.23A1.23,1.23,0,0,1,199.12,357.25Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67,351.8a.91.91,0,0,1-1.29,0,.91.91,0,1,1,1.29,0Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,348.4a1.52,1.52,0,0,0-2.15-.07,1.48,1.48,0,0,0-.43.73,1,1,0,1,0,.16,1.58.89.89,0,0,0,.16-.22l0,.06a1.52,1.52,0,1,0,2.22-2.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.53,352.7a1,1,0,0,1-1.36,0,1,1,0,0,1,1.4-1.32A1,1,0,0,1,200.53,352.7Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.77,350.87a.82.82,0,1,1,0-1.16A.82.82,0,0,1,219.77,350.87Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.88,347.8a1.36,1.36,0,0,0-2.32.6.91.91,0,1,0,.14,1.42.72.72,0,0,0,.14-.2.21.21,0,0,1,0,.06,1.37,1.37,0,1,0,2-1.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.83,351.68a.86.86,0,1,1,0-1.22A.86.86,0,0,1,217.83,351.68Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.47 350.79 302.25 356.99 324.39 368.95 354.5 362.31 331.47 350.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.05 350.79 281.88 365.85 308.89 366.73 319.96 352.12 296.05 350.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.4,339.72a14.94,14.94,0,0,1-7.14,9.74c-6.15,3.55-9.25,5.32-9.25,5.32l9.3,11.07s15.06-3.1,20.81-18.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,251.87,271.71,265l23.7,73.73s0,14.26,3.29,16.46c5.92,3.95,17.11,3.95,24.36-4.61s3.29-16.45,3.29-16.45L300,254.5s-3.29-9.22-10.53-10.53C279.55,242.16,267.1,243.31,265.12,251.87Z",
    style: {
      fill: "#F92323",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.69,300.85c-.82-.77-1.78-1.65-2.86-2.74-4.05-4.06-6.95-12.78-6.95-12.78v8.13c0,1.75,3.48,5.23,5.79,10.47s-1.74,9.29-1.74,9.29-.57-4.06-1.73-9.29-3.48-2.33-6.37-5.82a17.62,17.62,0,0,1-3.47-8.13v6.39c0,3.49,1.73,4.65,3.47,7.56s0,11,0,11a71.47,71.47,0,0,0-3.47-7c-1.74-2.9-2.9,0-3.59-2.4s-3.94-11.54-3.94-11.54a66.76,66.76,0,0,0-.58,9.88c0,6.39.58,3.48,2.32,7.55s2.31,5.81,1.15,11.62a20.12,20.12,0,0,0-.32,4.53L296,338.78s0,13.76,3.17,15.88c5.69,3.82,16.45,3.82,23.41-4.44s3.17-15.89,3.17-15.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.18 257.13 283.64 259.52 288.26 272.58 295.12 269.88 290.18 257.13",
    style: {
      fill: "#737373",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.12,260c-.72-2.91-2.44-5-3.84-4.65L294.82,257l2.64,10.57,4.46-1.6C303.32,265.58,303.85,262.93,303.12,260Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.66,261.61c.73,2.91.19,5.56-1.2,5.91s-3.11-1.74-3.84-4.66-.19-5.56,1.2-5.9S297.93,258.69,298.66,261.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.17,262.17c.33,1.31.14,2.49-.42,2.63s-1.29-.81-1.61-2.13-.14-2.49.42-2.63S296.84,260.85,297.17,262.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.6,268.11a1.58,1.58,0,0,1-.49-3.08l10-3.25a1.59,1.59,0,0,1,2,1,1.57,1.57,0,0,1-1,2l-10,3.24A1.4,1.4,0,0,1,284.6,268.11Z",
    style: {
      fill: "#737373",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.82,266.46c-.73-2.92-2.45-5-3.84-4.65l-4.46,1.59L280.16,274l4.46-1.59C286,272,286.55,269.37,285.82,266.46Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.36,268.05c.72,2.92.19,5.56-1.2,5.91s-3.11-1.73-3.84-4.65-.19-5.56,1.2-5.91S280.63,265.13,281.36,268.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.86,268.61c.33,1.32.14,2.5-.42,2.64s-1.28-.82-1.61-2.13-.14-2.49.42-2.63S279.54,267.3,279.86,268.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.2 321.62 306.67 324.01 311.29 337.07 318.14 334.36 313.2 321.62",
    style: {
      fill: "#737373",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.15,324.5c-.73-2.92-2.45-5-3.84-4.65l-4.46,1.59L320.49,332l4.46-1.59C326.34,330.06,326.88,327.42,326.15,324.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.69,326.09c.73,2.92.19,5.57-1.2,5.91s-3.11-1.73-3.84-4.65-.19-5.56,1.2-5.91S321,323.18,321.69,326.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.19,326.65c.33,1.32.14,2.5-.42,2.64s-1.28-.81-1.61-2.13-.14-2.49.42-2.63S319.87,325.34,320.19,326.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.62,332.6a1.58,1.58,0,0,1-.48-3.09l10-3.24a1.58,1.58,0,1,1,1,3l-10,3.24A1.62,1.62,0,0,1,307.62,332.6Z",
    style: {
      fill: "#737373",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84,330.94c-.73-2.91-2.45-5-3.84-4.65l-4.46,1.6,2.64,10.56,4.46-1.6C309,336.51,309.57,333.86,308.84,330.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38,332.54c.73,2.91.19,5.56-1.2,5.91s-3.11-1.74-3.84-4.65-.19-5.57,1.2-5.91S303.65,329.62,304.38,332.54Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.89,333.1c.33,1.31.14,2.49-.43,2.63s-1.28-.81-1.61-2.12-.14-2.5.43-2.64S302.56,331.78,302.89,333.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClutterBro);
export default __webpack_public_path__ + "static/media/Clutter-bro.b0b686139e90518b7da1a64a1e174fdc.svg";
export { ForwardRef as ReactComponent };